import type { MainCardProps } from "features/daily-delivery/types";
import { getVariantColor } from "features/daily-delivery/utils";
import styled from "styled-components";

export const Card = styled.button<MainCardProps>`
  all: unset;
  border: 1px solid ${({ variant }) => getVariantColor(variant)};
  padding: 6px 6px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 128px;
  min-height: 78px;
  background-color: var(--color-contrast-white, #ffffff);
  cursor: ${({ clickable }) => (clickable ? "pointer" : "default")};
`;
